/**
 * CellStyle class
 * @private
 */
export class CellStyle {
    constructor() {
        this.numFmtId = 0;
        this.backColor = 'none';
        this.fontName = 'Calibri';
        this.fontSize = 10.5;
        this.fontColor = '#000000';
        this.italic = false;
        this.bold = false;
        this.underline = false;
        this.strikeThrough = false;
        this.wrapText = false;
        this.hAlign = 'general';
        this.vAlign = 'bottom';
        this.indent = 0;
        this.rotation = 0;
        this.numberFormat = 'GENERAL';
        this.type = 'datetime';
        this.borders = new Borders();
        this.isGlobalStyle = false;
    }
}
/**
 * Font Class
 * @private
 */
export class Font {
    constructor() {
        this.sz = 10.5;
        this.name = 'Calibri';
        this.u = false;
        this.b = false;
        this.i = false;
        this.color = 'FF000000';
        this.strike = false;
    }
}
/**
 * CellXfs class
 * @private
 */
export class CellXfs {
}
/**
 * Alignment class
 * @private
 */
export class Alignment {
}
/**
 * CellStyleXfs class
 * @private
 */
export class CellStyleXfs {
}
/**
 * CellStyles class
 * @private
 */
export class CellStyles {
    constructor() {
        this.name = 'Normal';
        this.xfId = 0;
    }
}
/**
 * NumFmt class
 * @private
 */
export class NumFmt {
    constructor(id, code) {
        this.numFmtId = id;
        this.formatCode = code;
    }
}
/**
 * Border class
 * @private
 */
export class Border {
    constructor(mLine, mColor) {
        this.lineStyle = mLine;
        this.color = mColor;
    }
}
/**
 * Borders class
 * @private
 */
export class Borders {
    constructor() {
        this.left = new Border('none', '#FFFFFF');
        this.right = new Border('none', '#FFFFFF');
        this.top = new Border('none', '#FFFFFF');
        this.bottom = new Border('none', '#FFFFFF');
        this.all = new Border('none', '#FFFFFF');
    }
}
